export const configModule = {
    state() {
        return {
            config: {
                slogan: {
                    uk: '',
                    ru: '',
                },
                country: {
                    uk: '',
                    ru: ''
                },
                area: {
                    uk: '',
                    ru: '',
                },
                index: '',
                tel: {
                    one: '',
                    two: '',
                    tree: ''
                }
            },
        }
    },

    getters: {
        config(state) {
            return state.config
        }
    },

    mutations: {
        setConfig(state, data) {
            data.map(function (item) {
                if (item.name === 'slogan-uk') {
                    state.config.slogan.uk = item.value
                }
                if (item.name === 'slogan-ru') {
                    state.config.slogan.ru = item.value
                }
                if (item.name === 'tel-1') {
                    state.config.tel.one = item.value
                }
                if (item.name === 'tel-2') {
                    state.config.tel.two = item.value
                }
                if (item.name === 'tel-3') {
                    state.config.tel.tree = item.value
                }
                if (item.name === 'area-uk') {
                    state.config.area.uk = item.value
                }
                if (item.name === 'area-ru') {
                    state.config.area.ru = item.value
                }
                if (item.name === 'country-uk') {
                    state.config.country.uk = item.value
                }
                if (item.name === 'country-ru') {
                    state.config.country.ru = item.value
                }
                if (item.name === 'index') {
                    state.config.index = item.value
                }
            })
        }
    },

    actions: {
        async getConfigurations({ commit }) {
            await axios.get('/api/config').then((res) => {
                commit('setConfig', res.data)
            }).catch((err) => {

            })
        },
    },

    namespaced: true,
}